var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "news-part"
  }, [_c("Title", {
    staticClass: "title",
    attrs: {
      title: "他们都选择了同花顺资讯"
    }
  }), _c("section", {
    staticClass: "news-part_wrapper"
  }, _vm._l(_vm.cardList, function (item, index) {
    return _c("BrokerCard", {
      key: index,
      attrs: {
        url: item.url,
        text: item.text
      }
    });
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };